import type { ReactNode } from 'react';
import { ApiError } from '../api/client';

export function StatusBadge({ status }: { status: string }) {
  return <span className={`badge badge--${status}`}>{status.replace(/_/g, ' ')}</span>;
}

export function ProblemAlert({ error }: { error: unknown }) {
  if (!error) return null;
  if (error instanceof ApiError) {
    return (
      <div role="alert" className="alert">
        <strong>{error.problem.title}</strong>
        {error.problem.detail && <p>{error.problem.detail}</p>}
        {error.problem.errors && error.problem.errors.length > 0 && (
          <ul>
            {error.problem.errors.map((e, i) => (
              <li key={i}>
                {e.field && <code>{e.field}</code>} {e.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
  return (
    <div role="alert" className="alert">
      {error instanceof Error ? error.message : 'Something went wrong'}
    </div>
  );
}

export function Field({ label, children, hint }: { label: string; children: ReactNode; hint?: string }) {
  return (
    <label>
      {label}
      {children}
      {hint && <span className="hint">{hint}</span>}
    </label>
  );
}

export function DefinitionList({ items }: { items: Array<[string, ReactNode]> }) {
  return (
    <dl className="dl">
      {items.map(([k, v]) => (
        <div key={k}>
          <dt>{k}</dt>
          <dd>{v ?? <span className="muted">—</span>}</dd>
        </div>
      ))}
    </dl>
  );
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' });
}
